// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "8b5ed8985d0b318c97e9" + ".chunk.js";
};